import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import icon from '@design-system/Assets/close.png';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';
import { Text } from '@design-system/';

const Background = styled.div`
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.2s ease-in both;
  transition: 0.3s all;
  overflow: auto;
  top: 0;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 400;
`;

const Mod = styled.div`
  ${mediaQuery.desktop`
display: flex;
justify-content: center;
align-content: center;
justify-content: center;
padding: 100px;
`}
  display: flex;
  justify-content: center;
  align-content: center;
  justify-content: center;
`;

const ModalWrapper = styled.div`
  ${mediaQuery.desktop`
width: ${(props) => (props.width ? props.width : '572px')};
height:${(props) => (props.height ? props.height : 'auto')};
${'' /* overflow-y: scroll; */}
box-shadow: 0 5px 16px rgba(0,0,0,0,2);
background: #fff;
color:#000;
z-index: 500;
border-radius: 10px;
padding: 10px;
`}
  width: 350px;
  height: ${(props) => (props.height ? props.height : 'auto')};
  ${'' /* overflow-y: scroll; */}
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0, 2);
  background: #fff;
  color: #000;
  position: relative;
  z-index: 500;
  border-radius: 10px;
  padding: 10px;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    cursor: pointer;
  }
`;

const ModalBody = styled.div`
  padding: 0.5rem;
`;

export const Modal = ({ show, close, title, children, ...props }) => {
  return (
    <>
      {show ? (
        <Background>
          <Mod>
            <ModalWrapper show={show} {...props}>
              <ModalHeader>
                <Text align="left" size="large">
                  {title}
                </Text>
                <div onClick={close}>
                  <img src={icon} alt="close" />
                </div>
              </ModalHeader>
              <ModalBody>{children}</ModalBody>
            </ModalWrapper>
          </Mod>
        </Background>
      ) : null}
    </>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  title: '',
};
